import simpleRequest from '@/request/simple'
import handler from '@/utils/responseHandler'

export default {
  //活动下线检查
  checkOffline(data = {}) {
    data.pid = 335771

    return simpleRequest('ticket')({
      url: '/gateway/gtgj/act2',
      data,
      sidFields: ['uid', 'pid']
    }).then(handler.resBdData)
      .catch(() => {
        return false
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/offline.js